// keep these scss files as separate modules for faster builds (import here instead in the global scss)

import './styles/app.scss';

import './js/forms/form';
import './js/forms/registered-data';
import './js/app';
import './js/workflow-form';
import './js/application';
import './js/vote';
import './js/winners';
import './js/layout/navigation';
import './js/rabc';
import './js/4oclock/custom';
import './js/4oclock/prelogin';
import './js/4oclock/survey';
import './js/4oclock/winner-form';
import './js/4oclock/rabc-survey-detail';
import './js/4oclock/marketing-consent';
import './js/contentbuilder/index';
import './js/page/download';
import './js/4oclock/fleet-tbr';
